import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/cooperative/jdlogo.png'
import _imports_1 from '../../../public/img/cooperative/partner_icon.png'
import _imports_2 from '../../../public/img/cooperative/kingdee_logo.png'
import _imports_3 from '../../../public/img/cooperative/youzan_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-17a0535a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"cooperative-box\" data-v-17a0535a><div style=\"width:30rem;top:37%;left:11%;position:relative;\" data-v-17a0535a><div style=\"height:auto;font-weight:800;color:#000;font-size:2.8rem;\" data-v-17a0535a>和我们，一起改变</div><div style=\"height:auto;font-weight:800;color:#323232;font-size:1.8rem;margin:7px 0;\" data-v-17a0535a>与分蛋一同，砥砺前行</div><div style=\"height:auto;font-weight:400;color:#A1A2A6;font-size:1.1rem;margin-top:2rem;\" data-v-17a0535a>分蛋科技始终保持着开放的态度，发挥自身多年的行业能力积累，为生态和行业伙伴赋能</div></div></div>", 1)
const _hoisted_2 = { class: "cooperative-partner" }
const _hoisted_3 = { class: "home-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"rgba(0,0,0,0.5)","font-weight":"600","letter-spacing":"0.3rem"} }, "PARTNER", -1))
const _hoisted_5 = {
  class: "title",
  style: {"display":"flex","align-items":"center","color":"#000","letter-spacing":"0.4rem","font-weight":"600","font-size":"1.8rem","margin":"7px 0"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("合 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("作 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("伙 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("伴 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc",
  style: {"color":"rgba(0,0,0,0.8)","font-weight":"500","letter-spacing":"0.150rem","font-size":"0.85rem"}
}, "完善的服务体系为企业数字化转型升级服务保驾护航", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"cooperative-partner-con1\" data-v-17a0535a><div class=\"cond\" data-v-17a0535a><div style=\"width:50%;min-width:45px;\" data-v-17a0535a><img src=\"" + _imports_0 + "\" alt=\"\" style=\"width:100%;\" data-v-17a0535a></div><div style=\"display:flex;flex-direction:column;margin-bottom:20px;\" data-v-17a0535a><div data-v-17a0535a><img src=\"" + _imports_1 + "\" alt=\"\" style=\"height:2.5vw;min-height:20px;\" data-v-17a0535a></div><div style=\"color:#323232;font-size:1vw;height:4rem;overflow:auto;\" data-v-17a0535a>作为京东集团面向企业、政府等机构的技术服务品牌，京东云是更懂产业的数智化解…</div></div></div><div class=\"cond\" data-v-17a0535a><div style=\"width:50%;min-width:45px;\" data-v-17a0535a><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:100%;\" data-v-17a0535a></div><div style=\"display:flex;flex-direction:column;margin-bottom:20px;\" data-v-17a0535a><div data-v-17a0535a><img src=\"" + _imports_1 + "\" alt=\"\" style=\"height:2.5vw;min-height:20px;\" data-v-17a0535a></div><div style=\"color:#323232;font-size:1vw;height:4rem;overflow:auto;\" data-v-17a0535a>金蝶国际软件集团有限公司（“金蝶国际”或“金蝶”）始创于1993 年，是香港联…</div></div></div><div class=\"cond\" data-v-17a0535a><div style=\"width:50%;min-width:45px;\" data-v-17a0535a><img src=\"" + _imports_3 + "\" alt=\"\" style=\"width:100%;\" data-v-17a0535a></div><div style=\"display:flex;flex-direction:column;margin-bottom:20px;\" data-v-17a0535a><div data-v-17a0535a><img src=\"" + _imports_1 + "\" alt=\"\" style=\"height:2.5vw;min-height:20px;\" data-v-17a0535a></div><div style=\"color:#323232;font-size:1vw;height:4rem;overflow:auto;\" data-v-17a0535a>有赞，是一个商家服务公司，于2012年11月在杭州贝塔咖啡馆孵化成立。我们帮助每…</div></div></div></div>", 1)
const _hoisted_12 = { class: "cooperative-partner-con2" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sapn = _resolveComponent("sapn")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_sapn, { class: "shu" }),
          _hoisted_7,
          _createVNode(_component_sapn, { class: "shu" }),
          _hoisted_8,
          _createVNode(_component_sapn, { class: "shu" }),
          _hoisted_9
        ]),
        _hoisted_10
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.imageRows, (row, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "con2-row",
            key: index
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (image, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "cond2",
                key: i
              }, [
                _createElementVNode("img", {
                  src: require(`../../../public/img/cooperative/${image}`),
                  alt: ""
                }, null, 8, _hoisted_13)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}